/* Generated by ai2react v0.102.0 - 2021-09-14 03:58 */
/* ai file: 07-the-chile.ai */

import { makeAi2React } from './src/index'
import img0 from './img/07-the-chile-large.svg'
import img1 from './img/07-the-chile-mobile.svg'

const styles = `
  #g-07-the-chile-box ,
  #g-07-the-chile-box .g-artboard {
    margin:0 auto;
  }
  #g-07-the-chile-box p {
    margin:0;
  }
  #g-07-the-chile-box .g-aiAbs {
    position:absolute;
  }
  #g-07-the-chile-box .g-aiImg {
    position:absolute;
    top:0;
    display:block;
    width:100% !important;
  }
  #g-07-the-chile-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-07-the-chile-box .g-aiPointText p { white-space: nowrap; }
  #g-07-the-chile-large {
    position:relative;
    overflow:hidden;
  }
  #g-07-the-chile-large p {
    font-family:Inter;
    font-weight:400;
    line-height:12px;
    height:auto;
    filter:alpha(opacity=100);
    -ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity:1;
    letter-spacing:-0.029em;
    font-size:10px;
    text-align:left;
    color:rgb(0,0,0);
    text-transform:none;
    padding-bottom:0;
    padding-top:0;
    mix-blend-mode:normal;
    font-style:normal;
    position:static;
  }
  #g-07-the-chile-large .g-pstyle0 {
    font-weight:800;
    line-height:22px;
    height:22px;
    letter-spacing:-0.02em;
    font-size:18px;
  }
  #g-07-the-chile-large .g-pstyle1 {
    font-weight:700;
    line-height:13px;
    height:13px;
    letter-spacing:-0.019em;
    font-size:11px;
    color:rgb(101,54,148);
  }
  #g-07-the-chile-large .g-pstyle2 {
    font-weight:700;
    height:12px;
    letter-spacing:-0.02em;
  }
  #g-07-the-chile-large .g-pstyle3 {
    font-weight:700;
    line-height:10px;
    height:10px;
    letter-spacing:-0.019em;
    font-size:8px;
  }
  #g-07-the-chile-large .g-pstyle4 {
    height:12px;
  }
  #g-07-the-chile-large .g-pstyle5 {
    line-height:11px;
    height:11px;
    font-size:9px;
    color:rgb(88,89,91);
  }
  #g-07-the-chile-large .g-pstyle6 {
    line-height:11px;
    height:11px;
    letter-spacing:-0.03em;
    font-size:9px;
    color:rgb(88,89,91);
  }
  #g-07-the-chile-large .g-pstyle7 {
    line-height:10px;
    height:10px;
    letter-spacing:0em;
    font-size:8px;
    color:rgb(255,255,255);
  }
  #g-07-the-chile-large .g-pstyle8 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.019em;
    font-size:8px;
    color:rgb(255,255,255);
  }
  #g-07-the-chile-large .g-pstyle9 {
    line-height:13px;
    height:13px;
    font-size:11px;
  }
  #g-07-the-chile-large .g-cstyle0 {
    letter-spacing:-0.019em;
  }
  #g-07-the-chile-large .g-cstyle1 {
    letter-spacing:0em;
  }
  #g-07-the-chile-large .g-cstyle2 {
    letter-spacing:-0.02em;
  }
  #g-07-the-chile-large .g-cstyle3 {
    letter-spacing:-0.03em;
  }
  #g-07-the-chile-large .g-cstyle4 {
    letter-spacing:-0.032em;
  }
  #g-07-the-chile-large .g-cstyle5 {
    letter-spacing:-0.039em;
  }
  #g-07-the-chile-large .g-cstyle6 {
    letter-spacing:-0.041em;
  }
  #g-07-the-chile-large .g-cstyle7 {
    letter-spacing:-0.036em;
  }
  #g-07-the-chile-large .g-cstyle8 {
    letter-spacing:-0.035em;
  }
  #g-07-the-chile-large .g-cstyle9 {
    letter-spacing:-0.029em;
  }
  #g-07-the-chile-large .g-cstyle10 {
    letter-spacing:-0.033em;
  }
  #g-07-the-chile-large .g-cstyle11 {
    letter-spacing:-0.034em;
  }
  #g-07-the-chile-large .g-cstyle12 {
    letter-spacing:-0.044em;
  }
  #g-07-the-chile-large .g-cstyle13 {
    letter-spacing:-0.116em;
  }
  #g-07-the-chile-large .g-cstyle14 {
    letter-spacing:-0.086em;
  }
  #g-07-the-chile-large .g-cstyle15 {
    letter-spacing:-0.037em;
  }
  #g-07-the-chile-large .g-cstyle16 {
    letter-spacing:-0.11em;
  }
  #g-07-the-chile-large .g-cstyle17 {
    letter-spacing:-0.05em;
  }
  #g-07-the-chile-mobile {
    position:relative;
    overflow:hidden;
  }
  #g-07-the-chile-mobile p {
    font-family:Inter;
    font-weight:400;
    line-height:14px;
    height:auto;
    filter:alpha(opacity=100);
    -ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity:1;
    letter-spacing:-0.029em;
    font-size:11px;
    text-align:left;
    color:rgb(0,0,0);
    text-transform:none;
    padding-bottom:0;
    padding-top:0;
    mix-blend-mode:normal;
    font-style:normal;
    position:static;
  }
  #g-07-the-chile-mobile .g-pstyle0 {
    font-weight:800;
    line-height:22px;
    height:22px;
    letter-spacing:-0.02em;
    font-size:18px;
  }
  #g-07-the-chile-mobile .g-pstyle1 {
    font-weight:700;
    line-height:13px;
    height:13px;
    letter-spacing:-0.02em;
  }
  #g-07-the-chile-mobile .g-pstyle2 {
    font-weight:700;
    line-height:15px;
    height:15px;
    letter-spacing:-0.019em;
    font-size:12px;
    color:rgb(101,54,148);
  }
  #g-07-the-chile-mobile .g-pstyle3 {
    height:14px;
  }
  #g-07-the-chile-mobile .g-pstyle4 {
    height:14px;
    letter-spacing:-0.03em;
  }
  #g-07-the-chile-mobile .g-pstyle5 {
    line-height:13px;
    height:13px;
    color:rgb(88,89,91);
  }
  #g-07-the-chile-mobile .g-pstyle6 {
    line-height:12px;
    height:12px;
    letter-spacing:0em;
    font-size:10px;
    color:rgb(255,255,255);
  }
  #g-07-the-chile-mobile .g-pstyle7 {
    line-height:12px;
    height:12px;
    letter-spacing:-0.019em;
    font-size:10px;
    color:rgb(255,255,255);
  }
  #g-07-the-chile-mobile .g-pstyle8 {
    line-height:13px;
    height:13px;
    letter-spacing:-0.03em;
    color:rgb(88,89,91);
  }
  #g-07-the-chile-mobile .g-pstyle9 {
    line-height:13px;
    height:13px;
  }
  #g-07-the-chile-mobile .g-cstyle0 {
    letter-spacing:-0.019em;
  }
  #g-07-the-chile-mobile .g-cstyle1 {
    letter-spacing:0em;
  }
  #g-07-the-chile-mobile .g-cstyle2 {
    letter-spacing:-0.02em;
  }
  #g-07-the-chile-mobile .g-cstyle3 {
    letter-spacing:-0.03em;
  }
  #g-07-the-chile-mobile .g-cstyle4 {
    letter-spacing:-0.032em;
  }
  #g-07-the-chile-mobile .g-cstyle5 {
    letter-spacing:-0.029em;
  }
  #g-07-the-chile-mobile .g-cstyle6 {
    letter-spacing:-0.039em;
  }
  #g-07-the-chile-mobile .g-cstyle7 {
    letter-spacing:-0.041em;
  }
  #g-07-the-chile-mobile .g-cstyle8 {
    letter-spacing:-0.036em;
  }
  #g-07-the-chile-mobile .g-cstyle9 {
    letter-spacing:-0.033em;
  }
  #g-07-the-chile-mobile .g-cstyle10 {
    letter-spacing:-0.034em;
  }
  #g-07-the-chile-mobile .g-cstyle11 {
    letter-spacing:-0.086em;
  }
  #g-07-the-chile-mobile .g-cstyle12 {
    letter-spacing:-0.037em;
  }
  #g-07-the-chile-mobile .g-cstyle13 {
    letter-spacing:-0.05em;
  }
  #g-07-the-chile-mobile .g-cstyle14 {
    letter-spacing:-0.035em;
  }
  #g-07-the-chile-mobile .g-cstyle15 {
    letter-spacing:-0.044em;
  }
  #g-07-the-chile-mobile .g-cstyle16 {
    letter-spacing:-0.116em;
  }
  #g-07-the-chile-mobile .g-cstyle17 {
    letter-spacing:-0.11em;
  }

`

const html = props => `
<div id="g-07-the-chile-box" class="ai2html">


  <!-- Artboard: large -->
  <div id="g-07-the-chile-large" class="g-artboard" style="width:800px; height:489px;" data-aspect-ratio="1.636" data-min-width="800">
<div style=""></div>
    <img id="g-07-the-chile-large-img" class="g-aiImg" alt="" src="${img0}"/>
    <div id="g-ai0-1" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:5.6798%;margin-top:-12.8px;left:1.9669%;width:353px;">
      <p class="g-pstyle0"><span class="g-cstyle0">W</span>ORLD U<span class="g-cstyle0">N</span>IV<span class="g-cstyle0">E</span>RSI<span class="g-cstyle0">TY</span> RA<span class="g-cstyle0">N</span>KI<span class="g-cstyle0">N</span>GS 2022<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-2" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.7289%;margin-top:-7.5px;left:10.6646%;width:77px;">
      <p class="g-pstyle1"><span class="g-cstyle2">I</span>ns<span class="g-cstyle2">t</span>i<span class="g-cstyle2">t</span>u<span class="g-cstyle2">c</span>ió<span class="g-cstyle1">n</span></p>
    </div>
    <div id="g-ai0-3" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.7289%;margin-top:-7.5px;left:59.5948%;width:77px;">
      <p class="g-pstyle1"><span class="g-cstyle2">I</span>ns<span class="g-cstyle2">t</span>i<span class="g-cstyle2">t</span>u<span class="g-cstyle2">c</span>ió<span class="g-cstyle1">n</span></p>
    </div>
    <div id="g-ai0-4" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.582%;margin-top:-6.7px;left:2.5347%;width:68px;">
      <p class="g-pstyle2">RA<span class="g-cstyle0">N</span>KI<span class="g-cstyle0">N</span>G<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-5" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.582%;margin-top:-6.7px;left:51.6167%;width:68px;">
      <p class="g-pstyle2">RA<span class="g-cstyle0">N</span>KI<span class="g-cstyle0">N</span>G<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-6" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.4352%;margin-top:-6px;left:41.225%;width:55px;">
      <p class="g-pstyle3">Pun<span class="g-cstyle2">ta</span>j<span class="g-cstyle2">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-7" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.4352%;margin-top:-6px;left:90.1553%;width:55px;">
      <p class="g-pstyle3">Pun<span class="g-cstyle2">ta</span>j<span class="g-cstyle2">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-8" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:12.627%;margin-top:-6.7px;left:2.0965%;width:73px;">
      <p class="g-pstyle2"><span class="g-cstyle0">N</span>ACIO<span class="g-cstyle0">N</span>A<span class="g-cstyle1">L</span></p>
    </div>
    <div id="g-ai0-9" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:12.627%;margin-top:-6.7px;left:51.1785%;width:73px;">
      <p class="g-pstyle2"><span class="g-cstyle0">N</span>ACIO<span class="g-cstyle0">N</span>A<span class="g-cstyle1">L</span></p>
    </div>
    <div id="g-ai0-10" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:18.4265%;margin-top:-7.1px;left:10.6559%;width:199px;">
      <p class="g-pstyle4">P<span class="g-cstyle3">on</span>ti<span class="g-cstyle3">f</span>i<span class="g-cstyle3">c</span>i<span class="g-cstyle3">a</span> <span class="g-cstyle4">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">da</span>d C<span class="g-cstyle4">a</span>t<span class="g-cstyle3">ó</span>l<span class="g-cstyle3">i</span>c<span class="g-cstyle3">a d</span>e Ch<span class="g-cstyle3">ile</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-11" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:18.4265%;margin-top:-7.1px;left:59.5862%;width:136px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d An<span class="g-cstyle3">d</span><span class="g-cstyle4">r</span><span class="g-cstyle3">és</span> B<span class="g-cstyle3">ello</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-12" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:18.762%;margin-top:-6.7px;left:38.9106%;width:68px;">
      <p class="g-pstyle5"><span class="g-cstyle3">4</span><span class="g-cstyle5">0</span><span class="g-cstyle6">,</span>9&ndash;<span class="g-cstyle3">4</span><span class="g-cstyle7">4,</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-13" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:18.762%;margin-top:-6.7px;left:88.4173%;width:65px;">
      <p class="g-pstyle6">1<span class="g-cstyle5">0</span><span class="g-cstyle8">,</span><span class="g-cstyle9">6</span>-2<span class="g-cstyle9">2</span>,<span class="g-cstyle9">3</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-14" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:18.6151%;margin-top:-6px;left:5.1502%;width:28px;">
      <p class="g-pstyle7"><span class="g-cstyle0">1</span> </p>
    </div>
    <div id="g-ai0-15" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:18.6151%;margin-top:-6px;left:53.0364%;width:47px;">
      <p class="g-pstyle8"><span class="g-cstyle2">1</span>0-20<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-16" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.7884%;margin-top:-7.1px;left:10.6559%;width:165px;">
      <p class="g-pstyle4"><span class="g-cstyle10">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">A</span>utón<span class="g-cstyle3">o</span>ma d<span class="g-cstyle3">e</span> Ch<span class="g-cstyle3">il</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-17" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.7884%;margin-top:-7.1px;left:59.5862%;width:150px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d A<span class="g-cstyle3">u</span>str<span class="g-cstyle3">a</span>l d<span class="g-cstyle3">e</span> C<span class="g-cstyle3">h</span>i<span class="g-cstyle3">le</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-18" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:26.1239%;margin-top:-6.7px;left:39.0743%;width:66px;">
      <p class="g-pstyle5">3<span class="g-cstyle11">8</span>,1<span class="g-cstyle3">&ndash;4</span><span class="g-cstyle5">0</span>,<span class="g-cstyle3">8</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-19" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:26.1239%;margin-top:-6.7px;left:88.4173%;width:65px;">
      <p class="g-pstyle6">1<span class="g-cstyle5">0</span><span class="g-cstyle8">,</span><span class="g-cstyle9">6</span>-2<span class="g-cstyle9">2</span>,<span class="g-cstyle9">3</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-20" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.9771%;margin-top:-6px;left:4.5649%;width:38px;">
      <p class="g-pstyle8">2-4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-21" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.9771%;margin-top:-6px;left:53.0364%;width:47px;">
      <p class="g-pstyle8"><span class="g-cstyle2">1</span>0-20<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-22" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.3549%;margin-top:-7.1px;left:10.6559%;width:142px;">
      <p class="g-pstyle4"><span class="g-cstyle10">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">d</span>el<span class="g-cstyle3"> </span>D<span class="g-cstyle3">e</span>s<span class="g-cstyle3">a</span>r<span class="g-cstyle4">r</span><span class="g-cstyle3">o</span>ll<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-23" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.3549%;margin-top:-7.1px;left:59.5862%;width:129px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d d<span class="g-cstyle3">el </span>Bí<span class="g-cstyle3">o</span><span class="g-cstyle12">-</span>B<span class="g-cstyle3">í</span>o<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-24" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.6904%;margin-top:-6.7px;left:39.0743%;width:66px;">
      <p class="g-pstyle5">3<span class="g-cstyle11">8</span>,1<span class="g-cstyle3">&ndash;4</span><span class="g-cstyle5">0</span>,<span class="g-cstyle3">8</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-25" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.6904%;margin-top:-6.7px;left:88.4173%;width:65px;">
      <p class="g-pstyle6">1<span class="g-cstyle5">0</span><span class="g-cstyle8">,</span><span class="g-cstyle9">6</span>-2<span class="g-cstyle9">2</span>,<span class="g-cstyle9">3</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-26" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.5436%;margin-top:-6px;left:4.5649%;width:38px;">
      <p class="g-pstyle8">2-4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-27" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.5436%;margin-top:-6px;left:53.0364%;width:47px;">
      <p class="g-pstyle8"><span class="g-cstyle2">1</span>0-20<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-28" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:40.7169%;margin-top:-7.1px;left:10.6559%;width:145px;">
      <p class="g-pstyle4"><span class="g-cstyle10">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> D<span class="g-cstyle3">i</span>ego P<span class="g-cstyle3">o</span>rt<span class="g-cstyle3">a</span>l<span class="g-cstyle3">e</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-29" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:40.7169%;margin-top:-7.1px;left:59.5862%;width:160px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d <span class="g-cstyle3">C</span><span class="g-cstyle4">a</span><span class="g-cstyle3">t</span>ó<span class="g-cstyle3">l</span>i<span class="g-cstyle3">c</span>a d<span class="g-cstyle3">el</span> No<span class="g-cstyle3">r</span>t<span class="g-cstyle3">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-30" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:41.0524%;margin-top:-6.7px;left:39.0743%;width:66px;">
      <p class="g-pstyle5">3<span class="g-cstyle11">8</span>,1<span class="g-cstyle3">&ndash;4</span><span class="g-cstyle5">0</span>,<span class="g-cstyle3">8</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-31" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:41.0524%;margin-top:-6.7px;left:88.4173%;width:65px;">
      <p class="g-pstyle6">1<span class="g-cstyle5">0</span><span class="g-cstyle8">,</span><span class="g-cstyle9">6</span>-2<span class="g-cstyle9">2</span>,<span class="g-cstyle9">3</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-32" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:40.9055%;margin-top:-6px;left:4.5649%;width:38px;">
      <p class="g-pstyle8">2-4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-33" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:40.9055%;margin-top:-6px;left:53.0364%;width:47px;">
      <p class="g-pstyle8"><span class="g-cstyle2">1</span>0-20<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-34" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.0788%;margin-top:-7.1px;left:10.6559%;width:117px;">
      <p class="g-pstyle4"><span class="g-cstyle10">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span>Chi<span class="g-cstyle3">l</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-35" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.0788%;margin-top:-7.1px;left:59.5862%;width:212px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d <span class="g-cstyle13">T</span><span class="g-cstyle3">é</span>c<span class="g-cstyle3">n</span>i<span class="g-cstyle3">c</span>a F<span class="g-cstyle3">e</span>d<span class="g-cstyle3">e</span>ri<span class="g-cstyle3">co</span> Sant<span class="g-cstyle3">a</span> Ma<span class="g-cstyle3">r</span>ía<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-36" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.4143%;margin-top:-6.7px;left:39.3063%;width:65px;">
      <p class="g-pstyle5"><span class="g-cstyle3">2</span><span class="g-cstyle14">7</span>,<span class="g-cstyle3">2&ndash;</span>31<span class="g-cstyle6">,</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-37" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.4143%;margin-top:-6.7px;left:88.4173%;width:65px;">
      <p class="g-pstyle6">1<span class="g-cstyle5">0</span><span class="g-cstyle8">,</span><span class="g-cstyle9">6</span>-2<span class="g-cstyle9">2</span>,<span class="g-cstyle9">3</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-38" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.472%;margin-top:-6px;left:5.1332%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle0">5</span> </p>
    </div>
    <div id="g-ai0-39" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.472%;margin-top:-6px;left:53.0364%;width:47px;">
      <p class="g-pstyle8"><span class="g-cstyle2">1</span>0-20<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-40" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:55.6453%;margin-top:-7.1px;left:10.6559%;width:166px;">
      <p class="g-pstyle4"><span class="g-cstyle10">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> l</span>os A<span class="g-cstyle3">n</span>des, Ch<span class="g-cstyle3">i</span>le<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-41" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:55.6453%;margin-top:-7.1px;left:59.5862%;width:144px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d S<span class="g-cstyle3">a</span>n S<span class="g-cstyle3">e</span>bastián<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-42" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:55.9808%;margin-top:-6.7px;left:39.5725%;width:64px;">
      <p class="g-pstyle5"><span class="g-cstyle3">22</span>,<span class="g-cstyle3">4</span>-<span class="g-cstyle3">2</span><span class="g-cstyle14">7</span>,1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-43" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:55.9808%;margin-top:-6.7px;left:88.4173%;width:65px;">
      <p class="g-pstyle6">1<span class="g-cstyle5">0</span><span class="g-cstyle8">,</span><span class="g-cstyle9">6</span>-2<span class="g-cstyle9">2</span>,<span class="g-cstyle9">3</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-44" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:55.834%;margin-top:-6px;left:4.5915%;width:38px;">
      <p class="g-pstyle8">5-9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-45" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:55.834%;margin-top:-6px;left:53.0364%;width:47px;">
      <p class="g-pstyle8"><span class="g-cstyle2">1</span>0-20<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-46" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.0073%;margin-top:-7.1px;left:10.6559%;width:148px;">
      <p class="g-pstyle4"><span class="g-cstyle10">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span>Co<span class="g-cstyle3">n</span>cep<span class="g-cstyle3">c</span>ió<span class="g-cstyle3">n</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-47" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.0073%;margin-top:-7.1px;left:59.5862%;width:136px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d d<span class="g-cstyle3">e </span>Santiag<span class="g-cstyle3">o</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-48" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.3428%;margin-top:-6.7px;left:39.5725%;width:64px;">
      <p class="g-pstyle5"><span class="g-cstyle3">22</span>,<span class="g-cstyle3">4</span>-<span class="g-cstyle3">2</span><span class="g-cstyle14">7</span>,1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-49" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.3428%;margin-top:-6.7px;left:88.4173%;width:65px;">
      <p class="g-pstyle6">1<span class="g-cstyle5">0</span><span class="g-cstyle8">,</span><span class="g-cstyle9">6</span>-2<span class="g-cstyle9">2</span>,<span class="g-cstyle9">3</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-50" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.1959%;margin-top:-6px;left:4.5915%;width:38px;">
      <p class="g-pstyle8">5-9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-51" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.1959%;margin-top:-6px;left:53.0364%;width:47px;">
      <p class="g-pstyle8"><span class="g-cstyle2">1</span>0-20<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-52" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:70.5737%;margin-top:-7.1px;left:10.6559%;width:142px;">
      <p class="g-pstyle4"><span class="g-cstyle10">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> la</span> <span class="g-cstyle15">F</span><span class="g-cstyle4">r</span><span class="g-cstyle3">o</span>ntera<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-53" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:70.5737%;margin-top:-7.1px;left:59.5862%;width:118px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d d<span class="g-cstyle3">e </span><span class="g-cstyle16">T</span>a<span class="g-cstyle3">lc</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-54" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:70.9092%;margin-top:-6.7px;left:39.5725%;width:64px;">
      <p class="g-pstyle5"><span class="g-cstyle3">22</span>,<span class="g-cstyle3">4</span>-<span class="g-cstyle3">2</span><span class="g-cstyle14">7</span>,1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-55" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:70.9092%;margin-top:-6.7px;left:88.4173%;width:65px;">
      <p class="g-pstyle6">1<span class="g-cstyle5">0</span><span class="g-cstyle8">,</span><span class="g-cstyle9">6</span>-2<span class="g-cstyle9">2</span>,<span class="g-cstyle9">3</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-56" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:70.7624%;margin-top:-6px;left:4.5915%;width:38px;">
      <p class="g-pstyle8">5-9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-57" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:70.7624%;margin-top:-6px;left:53.0364%;width:47px;">
      <p class="g-pstyle8"><span class="g-cstyle2">1</span>0-20<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-58" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.9356%;margin-top:-7.1px;left:10.6559%;width:223px;">
      <p class="g-pstyle4">P<span class="g-cstyle3">on</span>ti<span class="g-cstyle3">f</span>i<span class="g-cstyle3">c</span>i<span class="g-cstyle3">a</span> <span class="g-cstyle4">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">da</span>d C<span class="g-cstyle4">a</span>t<span class="g-cstyle3">ó</span>l<span class="g-cstyle3">i</span>c<span class="g-cstyle3">a d</span>e <span class="g-cstyle17">V</span>a<span class="g-cstyle3">l</span>p<span class="g-cstyle3">a</span>r<span class="g-cstyle3">aí</span>s<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-59" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.9356%;margin-top:-7.1px;left:59.5862%;width:136px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d d<span class="g-cstyle3">e </span><span class="g-cstyle16">T</span>a<span class="g-cstyle3">r</span>apa<span class="g-cstyle3">c</span>á<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-60" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:78.2712%;margin-top:-6.7px;left:39.5725%;width:64px;">
      <p class="g-pstyle5"><span class="g-cstyle3">22</span>,<span class="g-cstyle3">4</span>-<span class="g-cstyle3">2</span><span class="g-cstyle14">7</span>,1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-61" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:78.2712%;margin-top:-6.7px;left:88.4173%;width:65px;">
      <p class="g-pstyle6">1<span class="g-cstyle5">0</span><span class="g-cstyle8">,</span><span class="g-cstyle9">6</span>-2<span class="g-cstyle9">2</span>,<span class="g-cstyle9">3</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-62" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:78.1243%;margin-top:-6px;left:4.5915%;width:38px;">
      <p class="g-pstyle8">5-9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-63" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:78.1243%;margin-top:-6px;left:53.0364%;width:47px;">
      <p class="g-pstyle8"><span class="g-cstyle2">1</span>0-20<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-64" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:85.2975%;margin-top:-7.1px;left:10.6559%;width:140px;">
      <p class="g-pstyle4"><span class="g-cstyle10">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">A</span>do<span class="g-cstyle3">lf</span>o Ibáñ<span class="g-cstyle3">e</span><span class="g-cstyle1">z</span></p>
    </div>
    <div id="g-ai0-65" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:85.2975%;margin-top:-7.1px;left:59.5862%;width:138px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d d<span class="g-cstyle3">e </span><span class="g-cstyle17">V</span>a<span class="g-cstyle3">l</span>paraí<span class="g-cstyle3">s</span><span class="g-cstyle1">o</span></p>
    </div>
    <div id="g-ai0-66" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:85.8376%;margin-top:-6.7px;left:39.4865%;width:63px;">
      <p class="g-pstyle5">1<span class="g-cstyle5">0</span><span class="g-cstyle7">,</span>6-<span class="g-cstyle3">22</span>,<span class="g-cstyle1">3</span></p>
    </div>
    <div id="g-ai0-67" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:85.8376%;margin-top:-6.7px;left:88.4173%;width:63px;">
      <p class="g-pstyle6">1<span class="g-cstyle5">0</span><span class="g-cstyle8">,</span><span class="g-cstyle9">6</span>-2<span class="g-cstyle9">2</span>,<span class="g-cstyle1">3</span></p>
    </div>
    <div id="g-ai0-68" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:85.6908%;margin-top:-6px;left:3.9551%;width:45px;">
      <p class="g-pstyle8">10<span class="g-cstyle2">-</span>2<span class="g-cstyle1">0</span></p>
    </div>
    <div id="g-ai0-69" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:85.6908%;margin-top:-6px;left:53.0364%;width:45px;">
      <p class="g-pstyle8"><span class="g-cstyle2">1</span>0-2<span class="g-cstyle1">0</span></p>
    </div>
    <div id="g-ai0-70" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:93.3465%;margin-top:-7.5px;left:1.9582%;width:237px;">
      <p class="g-pstyle9">(<span class="g-cstyle3">*</span>) <span class="g-cstyle11">F</span>u<span class="g-cstyle3">e</span>n<span class="g-cstyle3">t</span>e:  <span class="g-cstyle3">w</span>w<span class="g-cstyle12">w</span><span class="g-cstyle8">.</span>t<span class="g-cstyle3">i</span>m<span class="g-cstyle3">e</span>s<span class="g-cstyle3">h</span>ig<span class="g-cstyle3">he</span><span class="g-cstyle4">r</span>e<span class="g-cstyle3">d</span>uc<span class="g-cstyle10">a</span>tio<span class="g-cstyle3">n.</span>c<span class="g-cstyle3">o</span><span class="g-cstyle1">m</span></p>
    </div>
  </div>

  <!-- Artboard: mobile -->
  <div id="g-07-the-chile-mobile" class="g-artboard" style="max-width: 320px;max-height: 967px" data-aspect-ratio="0.331" data-min-width="0" data-max-width="799">
<div style="padding: 0 0 302.1875% 0;"></div>
    <img id="g-07-the-chile-mobile-img" class="g-aiImg" alt="" src="${img1}"/>
    <div id="g-ai1-1" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:3.4851%;margin-top:-23.7px;left:2.4171%;width:205px;">
      <p class="g-pstyle0"><span class="g-cstyle0">W</span>ORLD U<span class="g-cstyle0">N</span>IV<span class="g-cstyle0">E</span>RSI<span class="g-cstyle0">TY</span> </p>
      <p class="g-pstyle0">RA<span class="g-cstyle0">N</span>KI<span class="g-cstyle0">N</span>GS 2022<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-2" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:7.7081%;margin-top:-7.5px;left:68.3168%;width:64px;">
      <p class="g-pstyle1">Puntaje </p>
    </div>
    <div id="g-ai1-3" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:7.8443%;margin-top:-8.9px;left:27.9681%;width:85px;">
      <p class="g-pstyle2"><span class="g-cstyle2">I</span>ns<span class="g-cstyle2">t</span>i<span class="g-cstyle2">t</span>u<span class="g-cstyle2">c</span>ió<span class="g-cstyle1">n</span></p>
    </div>
    <div id="g-ai1-4" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:7.8115%;margin-top:-7.5px;left:2.3582%;width:74px;">
      <p class="g-pstyle1">RA<span class="g-cstyle0">N</span>KI<span class="g-cstyle0">N</span>G<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-5" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:8.949%;margin-top:-7.5px;left:2.1783%;width:80px;">
      <p class="g-pstyle1"><span class="g-cstyle0">N</span>ACIO<span class="g-cstyle0">N</span>A<span class="g-cstyle1">L</span></p>
    </div>
    <div id="g-ai1-6" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:12.4382%;margin-top:-15.3px;left:14.4344%;width:135px;">
      <p class="g-pstyle3">P<span class="g-cstyle3">on</span>ti<span class="g-cstyle3">f</span>i<span class="g-cstyle3">c</span>i<span class="g-cstyle3">a</span> <span class="g-cstyle4">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">da</span>d </p>
      <p class="g-pstyle4"><span class="g-cstyle5">C</span><span class="g-cstyle4">a</span><span class="g-cstyle5">t</span>ó<span class="g-cstyle5">l</span>i<span class="g-cstyle5">c</span>a d<span class="g-cstyle5">e Ch</span>ile<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-7" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:12.465%;margin-top:-7.5px;left:66.351%;width:74px;">
      <p class="g-pstyle5"><span class="g-cstyle3">4</span><span class="g-cstyle6">0</span><span class="g-cstyle7">,</span>9&ndash;<span class="g-cstyle3">4</span><span class="g-cstyle8">4,</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-8" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:12.3805%;margin-top:-6.7px;left:6.5971%;width:29px;">
      <p class="g-pstyle6"><span class="g-cstyle0">1</span> </p>
    </div>
    <div id="g-ai1-9" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.3679%;margin-top:-15.3px;left:14.4344%;width:122px;">
      <p class="g-pstyle3"><span class="g-cstyle9">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> </p>
      <p class="g-pstyle3"><span class="g-cstyle3">A</span>utón<span class="g-cstyle3">o</span>ma d<span class="g-cstyle3">e</span> Ch<span class="g-cstyle3">il</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-10" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.8084%;margin-top:-7.5px;left:66.8164%;width:72px;">
      <p class="g-pstyle5">3<span class="g-cstyle10">8</span>,1<span class="g-cstyle3">&ndash;4</span><span class="g-cstyle6">0</span>,<span class="g-cstyle3">8</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-11" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.7239%;margin-top:-6.7px;left:4.9327%;width:41px;">
      <p class="g-pstyle7">2-4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-12" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:20.7113%;margin-top:-15.3px;left:14.4344%;width:95px;">
      <p class="g-pstyle3"><span class="g-cstyle9">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span></p>
      <p class="g-pstyle3"><span class="g-cstyle3">d</span>el<span class="g-cstyle3"> </span>D<span class="g-cstyle3">e</span>s<span class="g-cstyle3">a</span>r<span class="g-cstyle4">r</span><span class="g-cstyle3">o</span>ll<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-13" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:21.0483%;margin-top:-7.5px;left:66.8164%;width:72px;">
      <p class="g-pstyle5">3<span class="g-cstyle10">8</span>,1<span class="g-cstyle3">&ndash;4</span><span class="g-cstyle6">0</span>,<span class="g-cstyle3">8</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-14" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:20.9638%;margin-top:-6.7px;left:4.9327%;width:41px;">
      <p class="g-pstyle7">2-4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-15" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.158%;margin-top:-15.3px;left:14.4344%;width:99px;">
      <p class="g-pstyle3"><span class="g-cstyle9">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> </p>
      <p class="g-pstyle3">D<span class="g-cstyle3">i</span>ego P<span class="g-cstyle3">o</span>rt<span class="g-cstyle3">a</span>l<span class="g-cstyle3">e</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-16" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.3916%;margin-top:-7.5px;left:66.8164%;width:72px;">
      <p class="g-pstyle5">3<span class="g-cstyle10">8</span>,1<span class="g-cstyle3">&ndash;4</span><span class="g-cstyle6">0</span>,<span class="g-cstyle3">8</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-17" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.3071%;margin-top:-6.7px;left:4.9327%;width:41px;">
      <p class="g-pstyle7">2-4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-18" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:29.4152%;margin-top:-8.4px;left:14.4344%;width:130px;">
      <p class="g-pstyle3"><span class="g-cstyle9">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span>Chi<span class="g-cstyle3">l</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-19" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:29.6315%;margin-top:-7.5px;left:67.4762%;width:70px;">
      <p class="g-pstyle5"><span class="g-cstyle3">2</span><span class="g-cstyle11">7</span>,<span class="g-cstyle3">2&ndash;</span>31<span class="g-cstyle7">,</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-20" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:29.547%;margin-top:-6.7px;left:6.5489%;width:30px;">
      <p class="g-pstyle6"><span class="g-cstyle0">5</span> </p>
    </div>
    <div id="g-ai1-21" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.7412%;margin-top:-15.3px;left:14.4344%;width:106px;">
      <p class="g-pstyle3"><span class="g-cstyle9">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span></p>
      <p class="g-pstyle3"><span class="g-cstyle3">l</span>os A<span class="g-cstyle3">n</span>des, Ch<span class="g-cstyle3">i</span>le<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-22" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.8714%;margin-top:-7.5px;left:68.2333%;width:70px;">
      <p class="g-pstyle5"><span class="g-cstyle3">22</span>,<span class="g-cstyle3">4</span>-<span class="g-cstyle3">2</span><span class="g-cstyle11">7</span>,1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-23" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.8904%;margin-top:-6.7px;left:5.0084%;width:41px;">
      <p class="g-pstyle7">5-9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-24" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:37.8777%;margin-top:-15.3px;left:14.4344%;width:101px;">
      <p class="g-pstyle3"><span class="g-cstyle9">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span></p>
      <p class="g-pstyle3">Co<span class="g-cstyle3">n</span>cep<span class="g-cstyle3">c</span>ió<span class="g-cstyle3">n</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-25" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:38.2148%;margin-top:-7.5px;left:68.2333%;width:70px;">
      <p class="g-pstyle5"><span class="g-cstyle3">22</span>,<span class="g-cstyle3">4</span>-<span class="g-cstyle3">2</span><span class="g-cstyle11">7</span>,1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-26" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:38.1303%;margin-top:-6.7px;left:5.0084%;width:41px;">
      <p class="g-pstyle7">5-9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-27" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:42.1177%;margin-top:-15.3px;left:14.4344%;width:101px;">
      <p class="g-pstyle3"><span class="g-cstyle9">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span></p>
      <p class="g-pstyle3"><span class="g-cstyle3">la</span> <span class="g-cstyle12">F</span><span class="g-cstyle4">r</span><span class="g-cstyle3">o</span>ntera<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-28" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:42.4547%;margin-top:-7.5px;left:68.2333%;width:70px;">
      <p class="g-pstyle5"><span class="g-cstyle3">22</span>,<span class="g-cstyle3">4</span>-<span class="g-cstyle3">2</span><span class="g-cstyle11">7</span>,1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-29" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:42.4736%;margin-top:-6.7px;left:5.0084%;width:41px;">
      <p class="g-pstyle7">5-9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-30" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:46.5644%;margin-top:-15.3px;left:14.4344%;width:138px;">
      <p class="g-pstyle3">P<span class="g-cstyle3">on</span>ti<span class="g-cstyle3">f</span>i<span class="g-cstyle3">c</span>i<span class="g-cstyle3">a</span> <span class="g-cstyle4">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">da</span>d</p>
      <p class="g-pstyle4"><span class="g-cstyle5">C</span><span class="g-cstyle4">a</span><span class="g-cstyle5">t</span>ó<span class="g-cstyle5">l</span>i<span class="g-cstyle5">c</span>a d<span class="g-cstyle5">e </span><span class="g-cstyle13">V</span><span class="g-cstyle5">a</span>l<span class="g-cstyle5">p</span>a<span class="g-cstyle5">r</span>aí<span class="g-cstyle5">s</span>o<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-31" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:46.798%;margin-top:-7.5px;left:68.2333%;width:70px;">
      <p class="g-pstyle5"><span class="g-cstyle3">22</span>,<span class="g-cstyle3">4</span>-<span class="g-cstyle3">2</span><span class="g-cstyle11">7</span>,1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-32" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:46.7135%;margin-top:-6.7px;left:5.0084%;width:41px;">
      <p class="g-pstyle7">5-9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-33" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:50.8216%;margin-top:-8.4px;left:14.4344%;width:156px;">
      <p class="g-pstyle3"><span class="g-cstyle9">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">A</span>do<span class="g-cstyle3">lf</span>o Ibáñ<span class="g-cstyle3">e</span><span class="g-cstyle1">z</span></p>
    </div>
    <div id="g-ai1-34" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:51.0379%;margin-top:-7.5px;left:67.9886%;width:68px;">
      <p class="g-pstyle5">1<span class="g-cstyle6">0</span><span class="g-cstyle8">,</span>6-<span class="g-cstyle3">22</span>,<span class="g-cstyle1">3</span></p>
    </div>
    <div id="g-ai1-35" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:50.9534%;margin-top:-6.7px;left:3.1984%;width:48px;">
      <p class="g-pstyle7">10<span class="g-cstyle2">-</span>2<span class="g-cstyle1">0</span></p>
    </div>
    <div id="g-ai1-36" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:54.7513%;margin-top:-8.4px;left:13.8808%;width:152px;">
      <p class="g-pstyle3"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d An<span class="g-cstyle3">d</span><span class="g-cstyle4">r</span><span class="g-cstyle3">és</span> B<span class="g-cstyle3">ello</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-37" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:54.9676%;margin-top:-7.5px;left:67.4362%;width:71px;">
      <p class="g-pstyle8">1<span class="g-cstyle6">0</span><span class="g-cstyle14">,</span><span class="g-cstyle5">6</span>-2<span class="g-cstyle5">2</span>,<span class="g-cstyle5">3</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-38" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:54.8831%;margin-top:-6.7px;left:3.0739%;width:51px;">
      <p class="g-pstyle7"><span class="g-cstyle2">1</span>0-20<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-39" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:59.0947%;margin-top:-8.4px;left:13.8808%;width:168px;">
      <p class="g-pstyle3"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d A<span class="g-cstyle3">u</span>str<span class="g-cstyle3">a</span>l d<span class="g-cstyle3">e</span> C<span class="g-cstyle3">h</span>i<span class="g-cstyle3">le</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-40" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:59.2075%;margin-top:-7.5px;left:67.4362%;width:71px;">
      <p class="g-pstyle8">1<span class="g-cstyle6">0</span><span class="g-cstyle14">,</span><span class="g-cstyle5">6</span>-2<span class="g-cstyle5">2</span>,<span class="g-cstyle5">3</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-41" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:59.2264%;margin-top:-6.7px;left:3.0739%;width:51px;">
      <p class="g-pstyle7"><span class="g-cstyle2">1</span>0-20<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-42" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.3346%;margin-top:-8.4px;left:13.8808%;width:143px;">
      <p class="g-pstyle3"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d d<span class="g-cstyle3">el </span>Bí<span class="g-cstyle3">o</span><span class="g-cstyle15">-</span>B<span class="g-cstyle3">í</span>o<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-43" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.5509%;margin-top:-7.5px;left:67.4362%;width:71px;">
      <p class="g-pstyle8">1<span class="g-cstyle6">0</span><span class="g-cstyle14">,</span><span class="g-cstyle5">6</span>-2<span class="g-cstyle5">2</span>,<span class="g-cstyle5">3</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-44" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.4664%;margin-top:-6.7px;left:3.0739%;width:51px;">
      <p class="g-pstyle7"><span class="g-cstyle2">1</span>0-20<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-45" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:67.4538%;margin-top:-15.3px;left:13.8808%;width:129px;">
      <p class="g-pstyle3"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d <span class="g-cstyle3">C</span><span class="g-cstyle4">a</span><span class="g-cstyle3">t</span>ó<span class="g-cstyle3">l</span>i<span class="g-cstyle3">c</span>a </p>
      <p class="g-pstyle3">d<span class="g-cstyle3">el</span> No<span class="g-cstyle3">r</span>t<span class="g-cstyle3">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-46" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:67.7908%;margin-top:-7.5px;left:67.4362%;width:71px;">
      <p class="g-pstyle8">1<span class="g-cstyle6">0</span><span class="g-cstyle14">,</span><span class="g-cstyle5">6</span>-2<span class="g-cstyle5">2</span>,<span class="g-cstyle5">3</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-47" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:67.7063%;margin-top:-6.7px;left:3.0739%;width:51px;">
      <p class="g-pstyle7"><span class="g-cstyle2">1</span>0-20<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-48" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:71.7971%;margin-top:-15.3px;left:13.8808%;width:133px;">
      <p class="g-pstyle3"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d <span class="g-cstyle16">T</span><span class="g-cstyle3">é</span>c<span class="g-cstyle3">n</span>i<span class="g-cstyle3">c</span>a</p>
      <p class="g-pstyle3">F<span class="g-cstyle3">e</span>d<span class="g-cstyle3">e</span>ri<span class="g-cstyle3">co</span> Sant<span class="g-cstyle3">a</span> Ma<span class="g-cstyle3">r</span>ía<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-49" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:72.1341%;margin-top:-7.5px;left:67.4362%;width:71px;">
      <p class="g-pstyle8">1<span class="g-cstyle6">0</span><span class="g-cstyle14">,</span><span class="g-cstyle5">6</span>-2<span class="g-cstyle5">2</span>,<span class="g-cstyle5">3</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-50" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:72.0496%;margin-top:-6.7px;left:3.0739%;width:51px;">
      <p class="g-pstyle7"><span class="g-cstyle2">1</span>0-20<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-51" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:76.1577%;margin-top:-8.4px;left:13.8808%;width:161px;">
      <p class="g-pstyle3"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d S<span class="g-cstyle3">a</span>n S<span class="g-cstyle3">e</span>bastián<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-52" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:76.374%;margin-top:-7.5px;left:67.4362%;width:71px;">
      <p class="g-pstyle8">1<span class="g-cstyle6">0</span><span class="g-cstyle14">,</span><span class="g-cstyle5">6</span>-2<span class="g-cstyle5">2</span>,<span class="g-cstyle5">3</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-53" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:76.2895%;margin-top:-6.7px;left:3.0739%;width:51px;">
      <p class="g-pstyle7"><span class="g-cstyle2">1</span>0-20<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-54" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:80.5011%;margin-top:-8.4px;left:13.8808%;width:152px;">
      <p class="g-pstyle3"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d d<span class="g-cstyle3">e </span>Santiag<span class="g-cstyle3">o</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-55" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:80.7174%;margin-top:-7.5px;left:67.4362%;width:71px;">
      <p class="g-pstyle8">1<span class="g-cstyle6">0</span><span class="g-cstyle14">,</span><span class="g-cstyle5">6</span>-2<span class="g-cstyle5">2</span>,<span class="g-cstyle5">3</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-56" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:80.6329%;margin-top:-6.7px;left:3.0739%;width:51px;">
      <p class="g-pstyle7"><span class="g-cstyle2">1</span>0-20<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-57" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:84.741%;margin-top:-8.4px;left:13.8808%;width:131px;">
      <p class="g-pstyle3"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d d<span class="g-cstyle3">e </span><span class="g-cstyle17">T</span>a<span class="g-cstyle3">lc</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-58" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:84.9573%;margin-top:-7.5px;left:67.4362%;width:71px;">
      <p class="g-pstyle8">1<span class="g-cstyle6">0</span><span class="g-cstyle14">,</span><span class="g-cstyle5">6</span>-2<span class="g-cstyle5">2</span>,<span class="g-cstyle5">3</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-59" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:84.8728%;margin-top:-6.7px;left:3.0739%;width:51px;">
      <p class="g-pstyle7"><span class="g-cstyle2">1</span>0-20<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-60" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:89.0843%;margin-top:-8.4px;left:13.8808%;width:151px;">
      <p class="g-pstyle3"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d d<span class="g-cstyle3">e </span><span class="g-cstyle17">T</span>a<span class="g-cstyle3">r</span>apa<span class="g-cstyle3">c</span>á<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-61" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:89.1972%;margin-top:-7.5px;left:67.4362%;width:71px;">
      <p class="g-pstyle8">1<span class="g-cstyle6">0</span><span class="g-cstyle14">,</span><span class="g-cstyle5">6</span>-2<span class="g-cstyle5">2</span>,<span class="g-cstyle5">3</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-62" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:89.2161%;margin-top:-6.7px;left:3.0739%;width:51px;">
      <p class="g-pstyle7"><span class="g-cstyle2">1</span>0-20<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-63" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:93.3242%;margin-top:-8.4px;left:13.8808%;width:154px;">
      <p class="g-pstyle3"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d d<span class="g-cstyle3">e </span><span class="g-cstyle13">V</span>a<span class="g-cstyle3">l</span>paraí<span class="g-cstyle3">s</span><span class="g-cstyle1">o</span></p>
    </div>
    <div id="g-ai1-64" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:93.5405%;margin-top:-7.5px;left:67.4362%;width:68px;">
      <p class="g-pstyle8">1<span class="g-cstyle6">0</span><span class="g-cstyle14">,</span><span class="g-cstyle5">6</span>-2<span class="g-cstyle5">2</span>,<span class="g-cstyle1">3</span></p>
    </div>
    <div id="g-ai1-65" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:93.456%;margin-top:-6.7px;left:3.0739%;width:48px;">
      <p class="g-pstyle7"><span class="g-cstyle2">1</span>0-2<span class="g-cstyle1">0</span></p>
    </div>
    <div id="g-ai1-66" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:97.7729%;margin-top:-7.5px;left:2.3955%;width:237px;">
      <p class="g-pstyle9">(<span class="g-cstyle3">*</span>) <span class="g-cstyle10">F</span>u<span class="g-cstyle3">e</span>n<span class="g-cstyle3">t</span>e:  <span class="g-cstyle3">w</span>w<span class="g-cstyle15">w</span><span class="g-cstyle14">.</span>t<span class="g-cstyle3">i</span>m<span class="g-cstyle3">e</span>s<span class="g-cstyle3">h</span>ig<span class="g-cstyle3">he</span><span class="g-cstyle4">r</span>e<span class="g-cstyle3">d</span>uc<span class="g-cstyle9">a</span>tio<span class="g-cstyle3">n.</span>c<span class="g-cstyle3">o</span><span class="g-cstyle1">m</span></p>
    </div>
  </div>


</div>
`

const containerId = 'g-07-the-chile-box'
const namespace = 'g-'
const name = '07-the-chile'

export default makeAi2React({ html, styles, containerId, namespace, name })

/* End ai2react - 2021-09-14 03:58 */
